import type { SxProps } from "@mui/material";

export const boxStyles: SxProps = {
  position: "relative",
  display: "flex",
  alignItems: "center",
  gap: 0.5,
  mr: 1,
  flex: 1,
};

export const inputStyles: SxProps = {
  "& .MuiInputBase-input": {
    minHeight: "24px",
    py: 1,
    pl: 1.5,
    pr: 3,
    fontSize: 14,
    mr: 1,
  },

  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E0E0E0 !important",
  },
};

export const buttonsBoxStyle: SxProps = {
  position: "absolute",
  display: "flex",
  alignItems: "center",
  top: 0,
  right: 0,
  bottom: 0,
  paddingRight: "5px",
  paddingLeft: 1,
  cursor: "pointer",
};
